import styled from 'styled-components';

export const PortalRoot = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999;
    pointer-events: none;

    &:empty {
        display: none;
    }

    & > * {
        pointer-events: auto;
    }
`;
